import 'twin.macro';
import React from 'react';
import ButtonRadio from '@teetsh/app/src/components/Form/ButtonsRadio';
import NumberInput from '@teetsh/app/src/components/Form/NumberInput/UpdateOnBlur';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { TrashIcon as Trash } from '@heroicons/react/20/solid';
import { css } from '@emotion/react';
import { Note } from 'containers/CarnetsDeNotes/types/carnetsDeNotes';
import { ABS, NE } from 'containers/CarnetsDeNotes/constants';

interface Props {
  value?: Note;
  onChange: (v?: number) => void;
  autoFocus?: boolean;
  onKeyPress?: (e: any) => void;
  inputRef?: any;
  notationSystem: NotationSystem;
  small?: boolean;
  'aria-label'?: string;
}

export function NumberNote(props: Props) {
  const {
    value,
    onChange,
    onKeyPress,
    autoFocus,
    inputRef,
    notationSystem,
    small,
  } = props;
  return (
    <div tw="flex justify-end items-center">
      <div
        css={css`
          flex-basis: 6rem;
        `}
      >
        <NumberInput
          fractionDigits={2}
          disabled={value?.note === undefined ? false : value?.note < 0}
          style={{
            fontWeight: 700,
            textAlign: 'right',
            color: notationSystem.getNoteColorContrast(value?.note),
          }}
          min={notationSystem.minValue || -2}
          max={
            notationSystem.noMaxValue
              ? Number.MAX_SAFE_INTEGER
              : notationSystem.maxValue || 100
          }
          tw="mb-0 font-bold"
          aria-label={props['aria-label']}
          onKeyPress={onKeyPress}
          autoFocus={autoFocus}
          inputRef={inputRef}
          onChange={v => {
            if (v === undefined) {
              return onChange(undefined);
            }
            const maxValue = notationSystem.maxValue ?? 100;
            const minValue = notationSystem.minValue ?? 0;

            if (v > maxValue && !notationSystem.noMaxValue) {
              return onChange(maxValue);
            }
            if (v < minValue) {
              return onChange(minValue);
            }
            return onChange(v);
          }}
          emptyValue=""
          value={
            value?.note === undefined || value?.note < 0
              ? undefined
              : notationSystem.getValue(value?.note, {
                  noteMax: value?.notationSystemMax,
                  noteMin: value?.notationSystemMin,
                })
          }
        />
      </div>
      <div tw="ml-2">
        <div tw="flex">
          <ButtonRadio<number | undefined>
            withoutMargin
            value={value?.note}
            canBeEmpty
            onChange={onChange}
            small={small}
            options={[
              {
                value: ABS.value,
                label: ABS.label,
                color: '#5c7080',
                tooltip: 'Absent',
              },
              {
                value: NE.value,
                label: NE.label,
                color: '#5c7080',
                tooltip: 'Non évalué',
              },
            ]}
          />
          <Button
            onClick={() => onChange(undefined)}
            minimal
            small={small}
            intent="danger"
            icon={Trash}
          />
        </div>
      </div>
    </div>
  );
}
